import { sendRequest } from "../../hooks/requests/useRequest";
import { ConfigServer } from '../../data/config';


export async function validateTicket(bodyInvoice) {
    let requestOptions = {
        method: "POST",
        body: JSON.stringify(bodyInvoice)
    };

    const response = await sendRequest(requestOptions, `InvoicePatient/ValidateTicket`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 404)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 429)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}



// * TAX REGIMEN
export async function getTaxRegimeByTypePerson(_is_moral, is_moral_person = null, _version) {

    let requestOptions = {
        method: "GET",
    };

    let queryParams = "";

    if (is_moral_person)
        queryParams = `fisica`;
    else {
        queryParams = `moral`;
    }

    const response = await sendRequest(requestOptions, `InvoicePatient/ListTaxRegimes/${queryParams}`);

    if (response.code)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}



// * USE CFDI
export async function getUseCfdi(_code) {

    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `InvoicePatient/ListUseOfCfdis/${_code}`);

    if (response.code)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}


// * CREATE INVOICE
export async function sendStampIngress(bodyInvoice) {
    let requestOptions = {
        method: "POST",
        body: JSON.stringify(bodyInvoice)
    };

    const response = await sendRequest(requestOptions, `InvoicePatient/Create`);

    if (response.code === 200)
        return {
            code_invoice: response?.data?.code_invoice,
            folio: response?.data?.folio,
            serie: response?.data?.serie,
            uuid: response?.data?.uuid,
            num_invoice: response?.data?.num_invoice,
            message: response?.data?.message
        }
    else if (response.code === 401)
        return {
            code: response?.data?.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response?.data?.code,
            msg: response?.data?.msg
        };
}







export async function DownloadInvoice(uuid_invoice) {
    try {

        const response = await sendRequest(
            {
                method: "POST"
            },
            `Invoice/DownloadPdfInvoice/${uuid_invoice}`
        );

        console.log("response:", response);

        const pdfBase64 = response?.data?.cadena;

        if (response?.code === 200 && pdfBase64) {

            const linkPdf = `data:application/pdf;base64,${pdfBase64}`;

            const downloadLink = document.createElement("a");

            downloadLink.href = linkPdf;
            downloadLink.download = `${uuid_invoice}.pdf`;

            document.body.appendChild(downloadLink);

            downloadLink.click();

            document.body.removeChild(downloadLink);

            return {
                code: 200
            };
        }

        return {
            code: response?.code || 400,
            msg: response?.data?.msg || "No se pudo descargar"
        };

    } catch (error) {

        return {
            code: 500,
            msg: error.message
        };
    }
}


export async function DownloadXml(id_invoice, uuid_invoice) {
    try {

        let token = localStorage.getItem("token");

        const response = await fetch(
            `${ConfigServer.serverUrl}/api/Invoice/DownloadXml/${id_invoice}`,
            {
                method: "POST",
                headers: new Headers({
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                })
            }
        );

        if (response.status !== 200) {
            return {
                code: response.status,
                msg: "No se descargó el archivo XML"
            };
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;
        link.download = `${uuid_invoice}.xml`;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        return {
            code: 200
        };

    } catch (error) {

        return {
            code: 500,
            msg: error.message
        };
    }
}






